// extracted by mini-css-extract-plugin
module.exports = {"form":"AuthForm_form__3CZBQ","heading":"AuthForm_heading__2vc-P","info":"AuthForm_info__2gRA3","link":"AuthForm_link__38OPu"};